import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import Footer from '../Landing2/Footer';
import NavBar from '../Landing2/NavBar';
import Seo from '../Seo/Seo';

const BlogList = ({ posts }) => {
  return (
    <div>
      <Seo
        title="Blog – Indie Filmmaking, Script Breakdowns & Film Budgets | Screenplayer"
        description="Guides for indie filmmakers, producers and screenwriters: script breakdowns, film budgeting, funding applications, screenwriting competitions and AI in pre-production."
        path="/blog"
      />
      <NavBar />
      <div className="blog-list-container">
        <div className="blog-grid">
          {posts.map((post) => (
            <article key={post.id} className="blog-card">
              {post.coverImage && (
                <div className="blog-card-image">
                  <img src={post.coverImage} alt={post.title} />
                </div>
              )}
              <div className="blog-card-content">
                <h2>{post.title}</h2>
                <p className="blog-date">{new Date(post.date).toLocaleDateString()}</p>
                <p className="blog-excerpt">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="read-more">
                  Read More →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogList; 